import { render, staticRenderFns } from "./DeveloperView.vue?vue&type=template&id=67858ce0&scoped=true&"
import script from "./DeveloperView.vue?vue&type=script&lang=ts&"
export * from "./DeveloperView.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperView.vue?vue&type=style&index=0&id=67858ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67858ce0",
  null
  
)

export default component.exports